"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.limitPages = limitPages;
exports.checkResults = checkResults;
exports.forEachPage = forEachPage;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume("next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen["return"] !== "function") { this["return"] = undefined; } }

if (typeof Symbol === "function" && Symbol.asyncIterator) { _AsyncGenerator.prototype[Symbol.asyncIterator] = function () { return this; }; }

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype["throw"] = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype["return"] = function (arg) { return this._invoke("return", arg); };

function _AwaitValue(value) { this.wrapped = value; }

function limitPages(_x, _x2) {
  return _limitPages.apply(this, arguments);
}

function _limitPages() {
  _limitPages = _wrapAsyncGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(cursor, pageLimit) {
    var pageCount, pageLimitReached, _ref, done, value;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageCount = 0;

          case 1:
            if (!(pageCount++ < pageLimit)) {
              _context.next = 14;
              break;
            }

            pageLimitReached = pageCount >= pageLimit;
            _context.next = 5;
            return _awaitAsyncGenerator(cursor.next());

          case 5:
            _ref = _context.sent;
            done = _ref.done;
            value = _ref.value;

            if (!(pageLimitReached || done)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", value);

          case 10:
            _context.next = 12;
            return value;

          case 12:
            _context.next = 1;
            break;

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _limitPages.apply(this, arguments);
}

function checkResults(_x3, _x4) {
  return _checkResults.apply(this, arguments);
}

function _checkResults() {
  _checkResults = _wrapAsyncGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(cursor, resultChecker) {
    var stopIteration, _ref2, done, value;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            stopIteration = false;

          case 1:
            if (!(stopIteration !== true)) {
              _context2.next = 14;
              break;
            }

            _context2.next = 4;
            return _awaitAsyncGenerator(cursor.next());

          case 4:
            _ref2 = _context2.sent;
            done = _ref2.done;
            value = _ref2.value;
            stopIteration = resultChecker(value);

            if (!(stopIteration || done)) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", value);

          case 10:
            _context2.next = 12;
            return value;

          case 12:
            _context2.next = 1;
            break;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _checkResults.apply(this, arguments);
}

function forEachPage(_x5, _x6) {
  return _forEachPage.apply(this, arguments);
}

function _forEachPage() {
  _forEachPage = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(cursor, pageHandler) {
    var done, results, response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            done = false;
            results = [];

          case 2:
            if (done) {
              _context3.next = 10;
              break;
            }

            _context3.next = 5;
            return cursor.next();

          case 5:
            response = _context3.sent;
            done = response.done;
            results.push(pageHandler(response.value));
            _context3.next = 2;
            break;

          case 10:
            return _context3.abrupt("return", results);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _forEachPage.apply(this, arguments);
}